<template>
  <div class="products">
    <section class="parallax-background mobile-display background fadeIn">
      <span class="font-weight-medium white--text title-label">{{
        $t("i18n.products")
      }}</span>
    </section>
    <section id="service">
      <div class="py-8"></div>
      <v-container class="text-center">
        <v-responsive class="mx-auto mb-4" width="56"></v-responsive>
        <v-responsive
          class="mx-auto font-weight-regular text-justify"
          max-width="1200"
          style="text-indent: 2em; font-size: 20px"
          >{{ $t("i18n.prointro") }}</v-responsive
        >
      </v-container>
    </section>
    <!--产品中心-->
    <section id="cases">
      <v-container class="text-center">
        <v-divider
          style="margin-right: 30% !important; margin-left: 30% !important"
        ></v-divider>
        <v-responsive class="mx-auto mb-6" width="56"></v-responsive>
        <v-row>
          <v-col cols="12" md="3">
            <div class="case-title">
              {{ $t("i18n.protitle") }}
            </div>
            <v-list height="100%">
              <v-list-group
                v-for="({ title, items }, i) in $t('i18n.prostitles')"
                :key="i"
                mandatory
                active-class="active-title"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item-title
                    style="white-space: pre-wrap"
                    v-text="title"
                  ></v-list-item-title>
                </template>
                <v-list-item
                  v-for="({ title, index }, j) in items"
                  :key="j"
                  link
                  @click="change(index)"
                >
                  <v-list-item-title
                    style="white-space: pre-wrap"
                    v-text="title"
                  ></v-list-item-title>
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-col>
          <v-col cols="12" md="9">
            <v-window v-model="window">
              <v-window-item
                v-for="{ title, img, index, text1, text2, text3 } in $t(
                  'i18n.prosdata'
                )"
                :key="index"
              >
                <v-card class="content" flat>
                  <v-card-title
                    v-text="title"
                    class="data-title"
                  ></v-card-title>
                  <v-row>
                    <v-col cols="12" md="5">
                      <v-card-title class="p-title"
                        ><v-icon color="#019fe8">mdi-ballot</v-icon
                        >{{ $t("i18n.proback") }}</v-card-title
                      >
                      <p class="p-text">{{ text1 }}</p>
                      <v-card-title class="p-title"
                        ><v-icon color="#019fe8">mdi-apps</v-icon
                        >{{ $t("i18n.profunction") }}</v-card-title
                      >
                      <p class="p-text" v-for="text in text2" :key="text">
                        ● {{ text }}
                      </p>
                      <v-card-title class="p-title"
                        ><v-icon color="#019fe8">mdi-arrow-up-bold-box</v-icon
                        >{{ $t("i18n.proadvance") }}</v-card-title
                      >
                      <p class="p-text" v-for="text in text3" :key="text">
                        ● {{ text }}
                      </p>
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-card-title class="p-title"
                        ><v-icon color="#019fe8">mdi-sitemap</v-icon
                        >{{ $t("i18n.prositmap") }}</v-card-title
                      >
                      <v-img style="margin: 2%" contain :src="img" />
                    </v-col>
                  </v-row>
                </v-card>
              </v-window-item>
            </v-window>
          </v-col>
        </v-row>
      </v-container>
      <div class="py-8"></div>
    </section>
  </div>
</template>

<script>
export default {
  mounted() {
    var hash = window.location.hash;
    var index = hash.lastIndexOf("#");
    if (index != -1) {
      var id = hash.substring(index + 1, hash.length + 1);
      var div = document.getElementById(id);
      if (div) {
        div.scrollIntoView();
      }
    }
  },
  created() {
    this.change(this.$route.query.index);
    if (this.$route.query.index > 0) {
      window.scrollTo(200, 400);
    }
  },
  data() {
    return {
      window: 0,
    };
  },
  methods: {
    change(index) {
      this.window = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.background {
  background: url(../assets/images/common/banner5.jpg) no-repeat;
  background-size: cover;
}
.tabs {
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
}
.active_tab {
  color: rgb(0, 0, 0) !important;
  font-size: 30px;
  text-decoration: none;
}
.content {
  border-radius: 0px !important;
  min-height: 660px;
}
.case-title {
  background: #019fe8;
  color: #fff !important;
  padding: 10px;
  font-size: 20px;
  font-weight: 500;
}
.active-title {
  background: #019fe8;
  color: #fff !important;
}
.data-title {
  background: #019fe8;
  color: #fff;
  padding: 10px;
  font-size: 20px;
  font-weight: 500;
}
.p-title {
  color: #019fe8;
  margin: 5px;
  width: fit-content;
  padding: 5px;
  border-bottom: 2px solid #019fe8;
  .v-icon {
    margin-right: 10px;
  }
}
.p-text {
  text-align: left;
  text-indent: 2em;
}
</style>